import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Logo from '../images/logo.png';
import DashIcon from '../images/home.png';
import MarketIcon from '../images/Vector.png';
import NotifiIcon from '../images/notificationIcon.png';
import profile from '../images/user-blue.png';
import { useLocation } from 'react-router-dom';
import menuIcon from '../images/menu.png'
import LogoutIcon from '../images/logout-icon.png'
import ChangePassword from '../images/padlock.png'
import UserProfile from '../images/user-profil.png'
import ConfirmLogoutModal from "./confirmLogoutModal";
import callingAPI from "../service"
import { clearDashboardData } from "../redux/reducers/dashboardSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setNotificationData, clearNotification } from "../redux/reducers/notificationSlice";
import { setDashboardData } from "../redux/reducers/dashboardSlice";
import { clearReport } from "../redux/reducers/reportSlice"
export default function Header(props) {
    const dispatch = useDispatch()
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const notificationData = useSelector((state) => state.notification?.notification || []);
    const [toggleMenu, setToggleMenu] = useState(false)
    const [active, setActive] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const menuRef = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);
    const toggleButtonRef = useRef(null);
    const isPasswordExpired = dashboardDetails.passwordExpired
    const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
    const refreshToken = dashboardDetails.refreshToken;
    const clientId = dashboardDetails.clientid;
    const userId = dashboardDetails.userId;
    const hasMarket = dashboardDetails.hasMarket;
    const clientName = dashboardDetails.clientname;

    useEffect(() => {
        const currentPath = location.pathname.replace('/', '');
        setActive(currentPath);
        getNotification()
    }, [location.pathname, props.show === true]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if the click is outside the menu and toggle button
            if (
                menuRef.current && !menuRef.current.contains(event.target) &&
                toggleButtonRef.current && !toggleButtonRef.current.contains(event.target)
            ) {
                setToggleMenu(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
    const getNotification = () => {
        const postData = {
            "userId": userId,
            "messageType": "",
            "fromDate": "",
            "toDate": "",
            "keywords": "",
            // //"refreshToken": refreshToken
        }
        callingAPI(postData, "notifications/getNotification", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    console.log("🚀 ~ .then ~ responsenotifuication:", data.data.notifications)
                    dispatch(setNotificationData({
                        notification: data.data.notifications,
                        category: data.data.categories
                    }));
                }
                else {
                    dispatch(setNotificationData({ notification: [] }));
                }
            }).catch((error) => {
                if (error.response && error.response.data) {
                    const { message, statusCode } = error.response.data;
                    console.error('Error during login:', statusCode, message);
                } else {
                    console.error('Error during login else:', error);
                }
            });
    }
    const handleNavigation = (page) => {
        setActive(page);
        dispatch(
            setDashboardData({
                reportValue: "",
                dashboardClick: "Dashboard"
            }

            ))
        if (page == "dashboard") {
            dispatch(
                setDashboardData({
                    reportValue: "Dashboard",
                    fromDate: new Date()
                }

                ))
            navigate(`/${page}`, { state: { directFlag: false } });
        }
        else {
            dispatch(
                setDashboardData({ reportValue: page }

                ))
            navigate(`/${page}`);
        }

    };
    const handleNavigationChanePassword = (page) => {
        navigate(`/${page}`);
    }

    const notificationClick = () => {
        dispatch(setNotificationData({ notificationDiv: true }));
        navigate('/notifications');

    };

    const toggleIcon = () => {
        console.log(toggleMenu)
        setToggleMenu(!toggleMenu)
    }
    const handleLogout = () => {
        setLogoutModalOpen(true);
    };

    const confirmLogout = () => {
        dispatch(setDashboardData({
            showDisclaimer: true
        }))

        dispatch(clearDashboardData());
        dispatch(clearNotification());
        dispatch(clearReport());
        // Navigate to the login page
        navigate('/');
        // Close the modal after logout
        setLogoutModalOpen(false);
    };

    const cancelLogout = () => {
        // Close the modal without logging out
        setLogoutModalOpen(false);
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleClickOutside = (event) => {
        // Ensure clicking the button doesn't trigger close
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            !buttonRef.current.contains(event.target)
        ) {
            setDropdownOpen(false);
        }
    };
    const handleNavigateDashboard = () => {
        // navigate('/dashboard');
        navigate("/dashboard", { state: { directFlag: false } });
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const unreadCount = notificationData.filter(notification => notification.isRead === "No").length;
    return (
        <div>
            <div className="header">
                <div className="container-fluid">
                    <div className="header-inner">
                        <div className="outer-sec">
                            <div className="header-menu" ref={toggleButtonRef}>
                                <img src={menuIcon} width={24} height={24} alt="menu" onClick={() => toggleIcon()} />
                            </div>
                            <div className="header-logo">
                                <img src={Logo} className="img-fluid" style={{ cursor: "pointer" }} width={103} height={28} alt="logo" onClick={() => handleNavigateDashboard()} />
                            </div>
                            {/* {isPasswordExpired === "0" &&
                                <div className={` ${isPasswordExpired === "0" && window.sessionStorage.getItem("hasMarket") !== "0" ? "marquee marquee-web" : "marquee-login marquee marquee-web"}`}>
                                    <div>
                                        <span>The stock prices displayed in this document are for informational purposes only and are not live. They may not reflect current market conditions and should not be relied upon for trading or investment decisions.</span>
                                    </div>
                                </div>} */}
                            <div className="user-list" ref={menuRef}>
                                <ul className={isPasswordExpired === "0" ? `user-list-ul user_mobile ${toggleMenu ? 'active-menu' : ''}` : `userli-padding user-list-ul user_mobile  ${toggleMenu ? 'active-menu' : ''}`}>
                                    {isPasswordExpired === "0" &&
                                        <li
                                            className={`d-flex-sec menu-border user-list-li ${active === 'dashboard' ? 'active' : ''}`}
                                            onClick={() => handleNavigation('dashboard')}
                                        >
                                            <img src={DashIcon} className="img-fluid user-list-li-img" width={22} height={22} alt="dash" />
                                            <span className="dash-menutext">Dashboard</span>
                                        </li>}
                                    {isPasswordExpired === "0" && hasMarket == "1" &&
                                        <li
                                            className={`d-flex-sec blinking-text user-list-li ${active === 'market' ? 'active' : ''}`}
                                            onClick={() => handleNavigation('market')}
                                        >
                                            <img src={MarketIcon} className="img-fluid user-list-li-img" width={20} height={20} alt="market" />
                                            <span className="dash-menutext">Buy and Sell</span>
                                        </li>
                                    }
                                </ul>
                                <ul className="user-list-ul ms-auto">
                                    {isPasswordExpired === "0" &&
                                        <li className="user-list-li " onClick={() => notificationClick()}>
                                            <img src={NotifiIcon} className="img-fluid user-list-li-img" width={24} height={24} alt="notification" />
                                            <span className="notification_outer">{unreadCount}</span>
                                        </li>}
                                    {isPasswordExpired === "0" &&
                                        <li className="user-list-li" ref={buttonRef} onClick={toggleDropdown}><img src={profile} className="img-fluid user-list-li-img" width={25} height={25} alt="profile" /></li>}
                                    {dropdownOpen && (
                                        <div ref={dropdownRef} className="dropdown-headerlogin">
                                            <ul>
                                                <li className="dropdwn-prfName-bg"><h2 className="dropdwn-prfName" title={clientName}>{clientName}</h2></li>
                                                <li
                                                    className="dropdwn-list-li"
                                                    onClick={() => handleNavigation('my-profile')}
                                                > <span><img src={UserProfile} alt="" className="img-fluid btn-Logout-header-img m-right-header" /></span><span className="padd-toptext">My Profile</span>
                                                </li>
                                                <li className="dropdwn-list-li" onClick={() => handleNavigationChanePassword('change-password')}><span><img src={ChangePassword} alt="" className="img-fluid btn-Logout-header-img m-right-header" /></span> <span className="padd-toptext">Change Password</span></li>
                                                <li className="dropdwn-list-li" onClick={() => handleLogout()}><span  ><img src={LogoutIcon} alt="" className="img-fluid btn-Logout-header-img m-right-header" /></span><span className="padd-toptext">Logout</span> </li>
                                            </ul>
                                        </div>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="marquee marquee-mob">
                            <div>
                                <span>This statement reflects transactions up to the date/time of issuance. Recent transactions may not yet be authorized and could be subject to charges, affecting your account value.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* {isLogoutModalOpen && */}
            <ConfirmLogoutModal
                isOpen={isLogoutModalOpen}
                onClose={cancelLogout}
                onConfirm={confirmLogout} />
            {/* } */}
        </div>
    );
}
